export default __webpack_public_path__ + "static/media/home-selected.7a5c281f.svg";